<template>
  <v-card>
    <v-form ref="startDateInfo" >
      <v-card-text class="c-d-flex c-align-center">
        <date-picker-with-max
            v-model="startDateModelValue"
            :date-only="true"
        >
          <template #activator>
            <v-text-field
                label="Start Date"
                :rules="[validationRules.required]"
                :value="startDateDisplayStr"
                readonly
            >
            </v-text-field>
          </template>
        </date-picker-with-max>
        <v-text-field
            prefix="R"
            type="number"
            label="USD to ZAR"
            v-model.number="modelValue.usdToZar"
            :rules="[validationRules.required]"
        />
      </v-card-text>
    </v-form>
    
    
    <v-card-actions>
      <v-btn
          v-if="showRemove"
          flat
          color="error"
          @click="remove"
      >
        Remove
      </v-btn>
      <v-spacer/>
      <v-btn
          flat
          color="disabled"
          @click="cancel"
      >
        Cancel
      </v-btn>
      <v-btn
          color="secondary"
          @click="save"
      >
        Done
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {validationRules} from "@/codeFunctions";
import format from "date-fns/format";
import DatePickerWithMax from "@/components/General/DatePickerWithMax.vue";

export default {
  components: {DatePickerWithMax},
  
  props: {
    showRemove: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Object,
      default: () => ({
        startDate: new Date(),
        usdToZar: 0,
      })
    },
  },
  data() {
    return {
      modelValue: {
        startDate: new Date(),
        usdToZar: 0,
      },
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        this.modelValue = {
          startDate: this.value.startDate || new Date(),
          usdToZar: this.value.usdToZar || 0,
        }
      }
    }
  },
  methods: {
    remove() {
      this.$emit('remove', this.value)
      this.$parent.$parent.save()
    },
    cancel() {
      this.$parent.$parent.save()
    },
    save() {
      if (!this.$refs.startDateInfo.validate())
        return this.$snack.error('Please fill out all required fields');
      this.$emit('input', this.modelValue)
      this.$parent.$parent.save()
    }
  },
  computed: {
    validationRules() {
      return validationRules
    },
    startDateDisplayStr() {
      return format(this.modelValue.startDate, 'YYYY-MM-DD')
    },
    startDateModelValue: {
      get() {
        return format(this.modelValue.startDate, 'YYYY-MM-DD')
      },
      set(val) {
        this.modelValue.startDate = new Date(val)
      }
    }
  },
}
</script>


<style scoped>

</style>